module.exports = __webpack_public_path__ + "img/pos-type-bg_hover.7eee075b.png";